
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/whitepaper",
      function () {
        return require("private-next-pages/whitepaper/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/whitepaper"])
      });
    }
  